import PadZero from './PadZero.js';

function FormatTime(ts, format){
  if(format === "HH:mm:ss.x"){  // 02:16:08.168
    //计算小时
    let hour = "";
    if(ts >= 60*60*1000){
      hour = Math.floor(ts/60/60/1000);
    }
    //计算分钟
    let minute = "";
    if(ts >= 60*1000){
      let tmpMM = ts;
      if(hour){
        tmpMM = ts - (hour*60*60*1000);
      }
      minute = Math.floor(tmpMM/60/1000);
    }
    //计算秒钟
    let ss = "";
    if(ts >= 1000){
      let tmpSS = ts;
      if(hour){
        tmpSS = ts - (hour*60*60*1000);
        if(minute){
          tmpSS = tmpSS - (minute*60*1000);
        }
      }else if(minute){
        tmpSS = ts - (minute*60*1000);
      }
      ss = Math.floor(tmpSS/1000);
    }
    let ms = parseInt((ts%1000)/100);
    if(hour){
      return PadZero("0", hour) + ":" + PadZero("0", minute) + ":" + PadZero("0", ss) + "." + ms;
    }else if(minute){
      return "00:" + PadZero("0", minute) + ":" + PadZero("0", ss) + "." + ms;
    }else if(ss){
      return "00:00:" + PadZero("0", ss) + "." + ms;
    }else{
      return "00:00:00." + ms;
    }
  }else if(format === "HH:mm:ss"){
    if(ts < 60){
      return "00:00:" + ts;
    }
    let min = Math.floor(ts/60);
    let sec = Math.floor(ts%60);
    if(min < 60){
      return "00:" + min + ":" + sec;
    }
    let hour = Math.floor(min/60);
    let min2 = Math.floor(min%60);
    return hour + ":" + min2 + ":" + sec;
  }
  return "";
}

export default FormatTime;